import { render, staticRenderFns } from "./PartExchange.vue?vue&type=template&id=507c32fe&scoped=true"
import script from "./PartExchange.vue?vue&type=script&setup=true&lang=ts"
export * from "./PartExchange.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PartExchange.vue?vue&type=style&index=0&id=507c32fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507c32fe",
  null
  
)

export default component.exports